import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center gap-3">
        <span className="w-16 h-16 flex items-center justify-center rounded-full bg-accent-100 mb-2">
          <i className="ri-emotion-sad-line text-accent-500 text-2xl"></i>
        </span>
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">P&aacute;gina n&atilde;o encontrada</h1>
        <p className="text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="text-base text-foreground-500 max-w-sm">Esta p&aacute;gina ainda n&atilde;o foi criada. Volte para a p&aacute;gina inicial e explore nossos guias.</p>
        <Link to="/" className="mt-4 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 transition-all text-sm font-semibold cursor-pointer whitespace-nowrap">
          <i className="ri-home-4-line"></i>
          Voltar ao In&iacute;cio
        </Link>
      </div>
    </div>
  );
}